import useViewContext, { ViewProvider } from "./context";

export default useViewContext;

export { ViewProvider };
